<template>
  <div class="finale-content-container">
    <div v-if="currentPage.endsWith('/finale')">
      <!--
      <h1>Coding Class finale 2024 d. 25. juni i Odense</h1>
     
      <img src="/static/images/finale/coding-class-finale-22.jpg" style="width: 100%; max-width: 1190px;"
        alt="konfetti fyldte luften til aarets coding class finale i 2021">

      <h2>Tak til alle for en fantastisk dag :)</h2>
      

      <h3>Vinderne af årets Coding Class finale blev:</h3>
      <p>
      <ul class="reset">
        <li>
          <p><b class="category">Innovation</b></p>
          <h3>Marvel Charms</h3>
          <h4>Paul Robin og Sebastian<br />Europaskolen, København</h4>
          <p>Prøv spillet på CoSpaces Edu: <a href="https://edu.cospaces.io/JFY-WPA">Marvel Charms</a></p>
        </li>
        <li>
          <p><b class="category">Gaming</b></p>
          <h3>The Adventure of Danny Dorito</h3>
          <h4>Naja, Simon og Frederik<br />6a Risingskolen, Odense</h4>
          <p>Prøv spillet på Scratch: <a href="https://scratch.mit.edu/projects/694735856/fullscreen/">The Adventure of
              Danny Dorito</a></p>
        </li>
        <li>
          <p><b class="category">Coding</b></p>
          <h3>Zombie Shooter</h3>
          <h4>Jacob og Viktor<br />6b Hjalleseskolen, Odense</h4>
          <p>Prøv spillet på Scratch: <a href="https://scratch.mit.edu/projects/687222963/fullscreen/">Zombie
              Shooter</a>
          </p>
        </li>
        <li>
          <p><b class="category">Publikumsprisen</b></p>
          <h3>Sommerhusudlejnings-quiz</h3>
          <h4>Viggo, Sixtus, Jakob og Zaysha<br />6c Korsager, København</h4>
          <p>Prøv quizzen på Scratch: <a
              href="https://scratch.mit.edu/projects/581210990/fullscreen/">Sommerhusudlejnings-quiz</a></p>
        </li>
      </ul>
      </p>

      <p>&nbsp;</p>
      <p>&nbsp;</p>
    </div>
    -->
      <h1>Coding Class finale 2024 d. 25. juni i Odense</h1>
    

      <a class="purp il sl" href="/finale/finalister">Finalister</a>
      <a class="purp il sl" href="/finale/workshops">Workshops</a>
      <!--<a class="purp il" href="/finale/info">Praktisk Info</a>-->

      <img style="margin-top: 20px" src="/static/images/finale/24/PROGRAM.svg" alt="">
    </div>
    <router-view v-else style="padding-bottom: 35px" />
  </div>
</template>

<script>
export default {
  computed: {
    currentPage() {
      return this.$route.path;
    },
  },
};
</script>

<style scoped>
.il {
  display: inline-block;
  width: 150px;
}
.sl {
  margin-right: 30px;
}
.finale-content-container {
  width: 100%;
}

p {
  margin: 0.5em 1.5em;
}

h4.stream {
  font-size: 28px;
  letter-spacing: 1px;
  margin: 0;
  display: inline-block;
  background-image: url("/static/images/finale/vote-btn-bgr.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

h4.stream a,
h4.stream a:hover,
h4.stream a:visited {
  display: inline-block;
  padding: 36px;
  color: #ffffff;
  text-decoration: none;
}

ul.reset {
  margin: 0;
  padding: 0;
  text-indent: 0;
  list-style: none;
}

ul.reset li {
  margin-top: 48px;
  text-indent: 0;
}

.category {
  padding: 6px;
  background: #00ffd4;
  color: #000000;
  border-radius: 3px;
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/finale/index.vue